import * as Yup from "yup";
export interface DraftOrderRequest {
  lineItems: DraftOrderLineItem[];
  taxExempt?: boolean;
  billingAddress?: string;
  shippingAddress?: DraftOrderAddress;
  marketRegionCountryCode?: string;
}
export interface DraftOrderAddress {
  address1?: string;
  address2?: string;
  city?: string;
  phone?: string;
  company?: string;
  countryCode?: string;
  country?: string;
  firstName?: string;
  lastName?: string;
  provinceCode?: string;
  zip?: string;
}
export interface DraftOrderLineItem {
  appliedDiscount?: number;
  quantity: number;
  title?: string;
  originalUnitPrice: number;
}
export interface CheckoutDetail {
  amount: string;
  billingName: string;
  billingAddress: string;
  billingPostalCode: string;
  transactionReference: string;
  cashierId: string;
  dmsSetupId?: string;
}
export const CheckoutInitialValues: CheckoutDetail = {
  amount: "",
  billingName: "",
  billingAddress: "",
  billingPostalCode: "",
  transactionReference: "",
  cashierId: "",
  dmsSetupId: "",
};

export const CheckoutValidationSchema = Yup.object().shape({
  billingName: Yup.string().required("Please Enter your Name"),
  billingAddress: Yup.string().required("Please Enter your Address"),
  billingPostalCode: Yup.string().required("Please Enter your Postal Code"),
});

export interface PartsCheckoutDetail {
  amount: string;
  email: string;
  phone: string;
  firstName: string;
  lastName?: string;
  middleName?: string;
  address: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  transactionReference: string;
  cashierId: string;
  dmsSetupId?: string;
  method: string;
  locationId: string;
}
export const PartsCheckoutInitialValues: PartsCheckoutDetail = {
  amount: "",
  email: "",
  phone: "",
  firstName: "",
  address: "",
  city: "",
  state: "",
  country: "",
  zip: "",
  transactionReference: "",
  cashierId: "",
  dmsSetupId: "",
  method: "shipping",
  locationId: "",
};

export const PartsCheckoutValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required()
    .required("Please Enter your First Name")
    .max(20, "First Name must be at most 20 characters")
    .matches(
      /^[A-Za-z\s]+$/,
      "Name cannot contain numbers or special characters"
    ),
  lastName: Yup.string()
    .max(20, "Last Name must be at most 20 characters")
    .matches(
      /^[A-Za-z\s]+$/,
      "Name cannot contain numbers or special characters"
    ),
  middleName: Yup.string()
    .max(20, "Middle Name must be at most 20 characters")
    .matches(
      /^[A-Za-z\s]+$/,
      "Name cannot contain numbers or special characters"
    ),
  email: Yup.string().required("Please Enter Email").email("Invalid Email"),
  method: Yup.string().required("Method is required"),
  phone: Yup.string()
    .required("Please Enter Phone")
    .min(7, "Enter valid Phone"),
  address: Yup.string().when("method", {
    is: "shipping",
    then: Yup.string().required("Address is required for shipping"),
  }),
  zip: Yup.string().when("method", {
    is: "shipping",
    then: Yup.string().required("Zip is required"),
  }),
  locationId: Yup.string().when("method", {
    is: "pickup",
    then: Yup.string().required("Location is required for Pickup"),
  }),
});
